import React, {FunctionComponent} from "react";
import {useIntl} from "react-intl";
import {StaffingPeriods} from "../../../interfaces/ResourceAvailabilityInterfaces";
import {IconSizeType} from "../../../types/bootstrap/BootstrapType";
import {dateUtils} from "../../../utils/dateUtils";
import Popover from "../../atoms/Popover";

interface StaffingPeriodsPopoverProps {
  className?: string,
  iconClassName?: string,
  staffingPeriods?: StaffingPeriods,
}

const StaffingPeriodsPopover: FunctionComponent<StaffingPeriodsPopoverProps> = ({
  className = "",
  iconClassName = "",
  staffingPeriods,
}) => {
  const intl = useIntl()

  if (!staffingPeriods?.startHour || !staffingPeriods?.endHour) {
    return null
  }

  const periodLabels = [
    staffingPeriods.onAm && intl.formatMessage({id: "staffing_period_am"}),
    staffingPeriods.onPm && intl.formatMessage({id: "staffing_period_pm"}),
    staffingPeriods.onNight && intl.formatMessage({id: "staffing_period_night"}),
  ].filter(Boolean)

  if (periodLabels.length === 0) {
    return null
  }

  const text = intl.formatMessage({id: "staffing_periods_tooltip"}, {
    periods: periodLabels.join(" + "),
    start: dateUtils.formatLocalTime(staffingPeriods.startHour),
    end: dateUtils.formatLocalTime(staffingPeriods.endHour),
  })

  return <Popover className={className} iconClassName={iconClassName} size={IconSizeType.XS} text={text}/>
}

export default StaffingPeriodsPopover
